(() => {
  if (customElements.get('results-item')) {
    return;
  }

  class ResultsItem extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Init Count Up.
     */
    initCountUp() {
      this.items.forEach((item) => {
        const countTo = Number(item.innerText);
        item.setAttribute('data-count-to', countTo);
        item.innerText = 0;
      });
    }

    /**
     * Count Up.
     */
    countUp() {
      this.items.forEach((item) => {
        const countUp = item;
        const countTo = Number(item.getAttribute('data-count-to'));
        const countFrom = 0;
        const duration = 400;

        let startTime = null;

        const step = (timestamp) => {
          if (!startTime) startTime = timestamp;

          const progress = Math.min((timestamp - startTime) / duration, 1);
          countUp.innerHTML = Math.floor(progress * (countTo - countFrom) + countFrom);

          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        };

        window.requestAnimationFrame(step);
      });
    }

    /**
     * Init intersection observer.
     */
    initIntersectionObserver() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.countUp();
      };

      const options = {
        root: null,
        rootMargin: '0px 0px -200px 0px',
        threshold: 1,
      };

      new IntersectionObserver(handleIntersection.bind(this), options).observe(this);
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.items = this.querySelectorAll('[data-count-up]');

      if (!this.items.length) {
        return;
      }

      this.initCountUp();
      this.initIntersectionObserver();
    }
  }

  customElements.define('results-item', ResultsItem);
})();
